import { Checkbox, IconButton, Tooltip } from '@material-ui/core';
import { AddBoxRounded } from '@material-ui/icons';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import {
  ListCard,
  ListCardSubtitle,
  ListCardTitle,
} from '../../../../common/components/cards';
import { createGroupVisitActions } from '../../groupVisits.actions';
import { GroupVisitDto } from '../../groupVisits.dtos';

interface IProps {
  groupVisit: GroupVisitDto;
}

const GroupVisitListItem: React.FC<IProps> = ({ groupVisit }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const openEditForm = () => history.push(`/group-visits/${groupVisit.id}`);

  const duplicateGroup = (gv: GroupVisitDto) => {
    gv.id = '';
    gv.leaderName = '';
    gv.isDuplicate = true;

    dispatch({
      type: getType(createGroupVisitActions.request),
      payload: { ...gv },
    });
  };

  return (
    <ListCard
      mediumSpan={6}
      onClick={openEditForm}
      title={<ListCardTitle title={groupVisit.groupName} statuses={[]} />}
      subtitles={[
        <ListCardSubtitle
          title={`${groupVisit.contact} | ${groupVisit.email} | ${groupVisit.phone}`}
          data={`Reservation ID: ${groupVisit.reservationId} Teacher/Leader Name: ${groupVisit.leaderName}`}
        />,
        <ListCardSubtitle
          title='Active'
          data={
            <Checkbox
              size='small'
              color='primary'
              checked={groupVisit.isActive}
              inputProps={{ readOnly: true }}
            />
          }
        />,
      ]}
      actionbutton={
        <Tooltip title='Duplicate group'>
          <IconButton
            onClick={(e: any) => {
              e.preventDefault();
              duplicateGroup(groupVisit);
            }}
            color='primary'
          >
            <AddBoxRounded />
          </IconButton>
        </Tooltip>
      }
    />
  );
};

export default GroupVisitListItem;
